import React, { Fragment } from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { unreadNumberLabel } from 'frontend_core/dist/helpers/format'
import { defaultLocale } from 'lib/i18n'
import MustHeader from 'containers/organisms/MustHeader'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/shared/GoogleTagManager'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsHeadStyle,
  GoogleAnalyticsHeadSecond,
} from 'components/shared/GoogleAnalytics'
import HeaderContainer from 'containers/organisms/HeaderContainer'
import Footer from 'components/shared/footer/Footer'
import 'components/styles'

export default function MainTemplate(props) {
  const { children, config } = props
  const title = props.title || i18n.t('server.shared.default_title')
  const siteName = i18n.t('server.shared.default_site_name')
  const pageTitle = `${title} | ${siteName}`
  const description = i18n.t(
    props.description || 'server.shared.default_description',
  )
  const url = props.url || ''
  const image = props.image || imagePath('www/common/ogimage.png')
  const bodyClassNames = ['site-service']
  if (props.bodyClassName) bodyClassNames.push(props.bodyClassName)

  const meta = {
    title: pageTitle,
    description,
    og: {
      title: pageTitle,
      description,
      url,
      image,
      siteName,
      type: 'website',
      locale: defaultLocale,
    },
    twitter: {
      title: pageTitle,
      description,
      url,
      image: { src: image },
      card: 'summary_large_image',
      site: '@spacemarketjp',
      creator: '@spacemarketjp',
    },
  }

  function renderAll(element) {
    return (
      <html lang={i18n.t('locale')}>
        <head>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
          <link rel="stylesheet" href={manifest['main.css']} media="screen" />
          <link
            rel="stylesheet"
            href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          />
          <link rel="shortcut icon" href={imagePath('www/favicon.ico')} />
          <link
            rel="apple-touch-icon"
            href={imagePath('common/apple-touch-icon.png')}
          />
          <meta property="fb:app_id" content={config.FB_APP_ID} />
          <meta property="og:site_name" content={meta.og.siteName} />
          <meta property="og:title" content={meta.og.title} />
          <meta property="og:description" content={meta.og.description} />
          <meta property="og:type" content={meta.og.type} />
          <meta property="og:url" content={meta.og.url} />
          <meta property="og:locale" content={meta.og.locale} />
          <meta property="og:image" content={meta.og.image} />
          <meta name="twitter:card" content={meta.twitter.card} />
          <meta name="twitter:site" content={meta.twitter.site} />
          <meta name="twitter:creator" content={meta.twitter.creator} />
          <meta name="twitter:title" content={meta.twitter.title} />
          <meta name="twitter:description" content={meta.twitter.description} />
          <meta name="twitter:url" content={meta.twitter.url} />
          <meta name="twitter:image:src" content={meta.twitter.image.src} />
          {props.linkCanonical && (
            <link rel="canonical" href={props.linkCanonical} />
          )}
          {props.linkNext && <link rel="next" href={props.linkNext} />}
          {props.linkPrev && <link rel="prev" href={props.linkPrev} />}
          <link rel="dns-prefetch" href="//www.spacemarket.com" />
          {props.appLinks && (
            <meta
              property="al:ios:url"
              content={`spacemarket:/${props.appLinks}`}
            />
          )}
          {props.appLinks && (
            <meta property="al:ios:app_store_id" content={meta.appStoreId} />
          )}
          {props.appLinks && (
            <meta property="al:ios:app_name" content={meta.name} />
          )}
          {props.amp && <link rel="amphtml" href={props.amp} />}
          <meta
            name="google-site-verification"
            content="cmoKhQQsQ4qUSCi8OyEvVogn5rLN77ObhTYe5pWXcBk"
          />
          <script type="text/javascript" src="https://js.stripe.com/v2/" />
          <script type="text/javascript" src="https://apps.paidy.com/" />
          <meta name="apple-itunes-app" content="app-id=973447544" />
          <link rel="manifest" href={manifest['manifest-public.json']} />
          <script src="https://cdn.onesignal.com/sdks/OneSignalSDK.js" async />
          <GoogleTagManagerHead />
          <GoogleAnalyticsHead
            config={props.config}
            currentUser={props.data.viewer}
          />
          <GoogleAnalyticsHeadStyle />
          <GoogleAnalyticsHeadSecond config={props.config} />
        </head>
        <body className={bodyClassNames.join(' ')}>
          <div id="js-root">{renderRoot()}</div>
          <GoogleTagManagerBody />
        </body>
      </html>
    )
  }

  function renderRoot() {
    const ui = props.ui || {}

    if (!config.SSR) {
      const label =
        props.data.viewer && props.data.viewer.newsNumber > 0
          ? `(${unreadNumberLabel(props.data.viewer.newsNumber)}) `
          : ''
      const title = props.title || i18n.t('server.shared.default_title')
      const siteName = i18n.t('server.shared.default_site_name')
      document.title = `${label}${title} | ${siteName}`
    }

    return (
      <Fragment>
        {!props.hideMustHeader && <MustHeader {...props} />}
        {props.addtionalComponent}
        <HeaderContainer {...props} />
        {!ui.isShowHeaderSearch && (
          <Fragment>
            <div className="site-main">{children}</div>
            <Footer {...props} />
          </Fragment>
        )}
      </Fragment>
    )
  }
  return config.SSR ? renderAll() : renderRoot()
}



// WEBPACK FOOTER //
// ./src/components/templates/MainTemplate/index.jsx